// Exact matches only: a customer subdomain must never become the public site.
export function isPublicHost(hostname) {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  return ['firetrack.fr', 'www.firetrack.fr', 'firetrack.local', 'www.firetrack.local'].includes(host);
}
